import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { RequestConfirmationSummary } from "@shared/models/operational-tasks"; // Adjust the path accordingly
import { ConfirmationService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";

@Component({
  selector: "app-request-confirmation-popup",
  standalone: true,
  imports: [CommonModule, ConfirmDialogModule, ButtonModule, TranslateModule],
  templateUrl: "./request-confirmation-popup.component.html",
  styleUrls: ["./request-confirmation-popup.component.scss"],
  providers: [ConfirmationService],
})
export class RequestConfirmationPopupComponent {
  @Output() dialogEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() confirmationSummary!: RequestConfirmationSummary;

  closePopup() {
    this.dialogEmitter.emit(false);
  }

  confirmRequest() {
    this.dialogEmitter.emit(true);
  }
}
